import { ChangeDetectorRef, Component,  OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FeatureSupportService } from 'src/app/services/feature-support.service';
import { HardwareSupportGuard } from '../../services/hardware-support-guard';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  redirect: boolean = false;

  constructor(
    public cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public fs: FeatureSupportService,
    private router: Router,
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    public hardwareSupport: HardwareSupportGuard) {}

  ngOnInit(): void {
    var url = new URL(window.location.href);
    this.redirect = !(url.host.endsWith(".emeo.music") || "localhost:4200" == url.host);

    console.debug("Redirect required? " + this.redirect);
  }

  can(...features: string[]) : boolean {
    return this.fs.can({  }, ...features);
  }

  clickedStart() {
    this.activeModal.close('main');
  }

  clickedRedirect() {
    this.activeModal.close('main');

    var location = new URL(window.location.href);
    var host = location.host;

    if (host.endsWith(".emeomusic.com")) {
      host = host.substring(0, host.length - ".emeomusic.com".length);
      host += ".emeo.music";
      location.host = host;
    }
    else if (host.endsWith("localhost:4200")) {
      location.host = "localhost:4200";
    }

    window.location.href = location.href;
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl], { queryParamsHandling: "preserve" });
  }
}
